/*
Developed by Shivam Arora
2 Apr 2026
 */

//lib
import { useState } from "react";
import "./ProductCard.css";

//components

//context

//css

function ProductCard({ product, onClick }) {
  const [hover, setHover] = useState(false);

  return (
    <div
      className="product-card"
      onClick={() => onClick(product.id)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div className="productImgWrap">
        <img
          src={hover ? product.images[1] : product.images[0]}
          className="product-img"
          alt={product.name}
        />
      </div>

      <div className="product-info">
        {product.tag && <span className="tag">{product.tag}</span>}
        <p className="name">{product.name}</p>
        <p className="price">₹{product.price}</p>
      </div>
    </div>
  );
}

export default ProductCard;
